<script>
import appConfig from "@/app.config";
import Social from "@/components/social.vue";

export default {
  props: {
    customClass: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      publicData: {},
      footerData: {},
    };
  },
  methods: {
    languageChanged(value) {
      this.footerData = this.publicData.data[value].footerData;
    },
    openDetailModal() {
      // if (this.$i18n.locale == "zh") {
      //   this.$bvModal.show("chinese-tv-dailog");
      // }
    },
  },
  created: function () {
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.publicData = window.publicData;
  },
  // components: { Social },
};
</script>
<template>
  <div>
    <div
      :class="$style.tvBlcok"
      class="rounded-14 flex-row d-flex align-items-center"
      @click="openDetailModal()"
    >
      <img
        :src="assetsPath + 'images/icons/TV-icon@2x.png'"
        alt=""
        :class="$style.tvImg"
      />
      <div class="mr-3 w-100">
        <h3>{{ this.$t("TvSocial.title") }}</h3>
        <p>{{ this.$t("TvSocial.subtitle") }}</p>
      </div>
      <div class="text-center" :class="$style.playBtn">
        <a target="_blank" :href="footerData.dpTvShare">
          <img :src="assetsPath + 'images/icons/yellow-play-icon.svg'" alt="" />
        </a>
      </div>
    </div>
    <div
      class="d-md-inline-block d-lg-inline-block d-xl-inline-block w-100"
      :class="[customClass]"
    >
      <!-- <Social /> -->
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.tvBlcok {
  background-color: $light-blue;
  padding: 43px 30px 28px;
  position: relative;
  .tvImg {
    position: absolute;
    width: 100px;
    top: -100px;
    right: 0;
    left: 0;
    margin: auto;
  }
  h3 {
    font-size: 24px;
    color: $yellow;
    margin-bottom: 0;
  }
  p {
    font-size: 16px;
    color: #8792c9;
    margin-bottom: 0;
  }
  .playBtn {
  }
}
@media screen and (max-width: 767px) {
  .tvBlcok {
    margin-top: 120px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .tvBlcok {
    h3 {
      font-size: 17px;
    }
    p {
      font-size: 9px;
    }
  }
}
</style>
